import { render, staticRenderFns } from "./wxuserlist.vue?vue&type=template&id=57b4c8fa&"
import script from "./wxuserlist.vue?vue&type=script&lang=js&"
export * from "./wxuserlist.vue?vue&type=script&lang=js&"
import style0 from "./wxuserlist.vue?vue&type=style&index=0&id=57b4c8fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports